import { render } from "./MNCASAUnderstandingSexualViolenceES.vue?vue&type=template&id=f17bc174&scoped=true"
import script from "./MNCASAUnderstandingSexualViolenceES.vue?vue&type=script&lang=js"
export * from "./MNCASAUnderstandingSexualViolenceES.vue?vue&type=script&lang=js"

import "./MNCASAUnderstandingSexualViolenceES.vue?vue&type=style&index=0&id=f17bc174&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17bc174"]])

export default __exports__